export const config = {
  base_url: process.env.NEXT_PUBLIC_API_URL || "/api",
};
